"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Button_1 = __importDefault(require("../Button"));

var RedirectButton_1 = __importDefault(require("../RedirectButton"));

var Actions_meta_1 = require("./Actions.meta");

var Actions =
/** @class */
function (_super) {
  __extends(Actions, _super);

  function Actions(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Actions_meta_1.ACTIONS_CATEGORY_KEY;
    _this.componentKey = Actions_meta_1.ACTIONS_COMPONENT_KEY;
    return _this;
  }

  Actions.prototype.isRedirectButton = function (props) {
    var redirect = ksys_app_template_1.utils.get(props, 'redirect');
    return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(redirect);
  };

  Actions.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        _b = _a.buttons,
        buttons = _b === void 0 ? [] : _b;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, buttons.map(function (buttonProps, index) {
      var key = "button_" + index;
      return _this.isRedirectButton(buttonProps) ? react_1.default.createElement(RedirectButton_1.default, __assign({
        key: key
      }, buttonProps)) : react_1.default.createElement(Button_1.default, __assign({
        key: key
      }, buttonProps));
    }));
  };

  Actions = __decorate([mobx_react_1.observer], Actions);
  return Actions;
}(shared_1.ComponentBase);

exports.Actions = Actions;
exports.default = shared_1.InjectedStyledComponent(Actions, Actions_meta_1.ACTIONS_CATEGORY_KEY, Actions_meta_1.ACTIONS_COMPONENT_KEY);